import React, { useEffect, useState } from 'react'
import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import { UserDocument } from '../lib/userDocuments.slice'
import { Input } from '@/ui'

export interface DocumentSearchBarOnChangeData {
  filtered: UserDocument[]
  original: UserDocument[]
  value: string
}

export interface DocumentSearchBarProps {
  documents: UserDocument[]
  onChange: (_data: DocumentSearchBarOnChangeData) => void
}

export const DocumentsSearchBar: React.FC<DocumentSearchBarProps> = ({
  documents,
  onChange,
}) => {
  const [value, setValue] = useState('')

  // When value changes, filter documents and call onChange prop above
  useEffect(() => {
    const filtered = documents.filter((doc) => {
      const fileName = doc.awsFileName.toLowerCase()
      const description = doc.fileDescription?.toLowerCase()
      const query = value.toLocaleLowerCase()
      return fileName.includes(query) || description?.includes(query)
    })

    onChange({
      filtered,
      original: documents,
      value,
    })
  }, [value, onChange, documents])

  return (
    <Input
      iconLeft={faSearch}
      iconRight={value.length > 0 ? faSearch : undefined}
      type="search"
      placeholder="Search documents..."
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        setValue(event.target.value)
      }
    />
  )
}
